<template>
    <div class="form-group">
        <label :class="[textMuted ? 'text-muted' : '', labelNowrap ? 'label-nowrap' : '']" :title="label">{{ label }}<span class="text-danger ml-1" v-if="required">*</span><slot name="labelAppend"></slot></label>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "FormGroup",
    props: {
        label: {
            type: String,
            default: () => translate('components.form_group.default_label')
        },
        required: {
            type: Boolean,
            default: false
        },
        labelNowrap: {
            type: Boolean,
            default: false
        },
        textMuted: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style scoped>
.label-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}
</style>